import { Component, Prop } from 'vue-property-decorator';
import InputBase from '@/components/inputs/base/InputBase';
import { store } from '@/store/store';

@Component
export default class InputNumber extends InputBase<string> {
  @Prop({ default: '', required: false }) public minInput?: number;
  @Prop({ default: '', required: false }) public maxInput?: number;
  @Prop({ default: '', required: false }) public errorMsg?: string;

  /**
   * Erro flag that shows or hide error message (from prop 'errorMsg')
   */
  public error: boolean = false;

  protected mounted() {
    this.inputType = 'text';
  }

  protected beforeDestroy() {
    this.resetInputValidity();
  }

  protected preventNonNumericalInput(e: any) {
    e = e || window.event;
    const charCode = (typeof e.which === undefined) ? e.keyCode : e.which;
    const charStr = String.fromCharCode(charCode);
    if (!charStr.match(/^[0-9]+$/)) {
      e.preventDefault();
    }
  }

  protected preventNonNumericalPaste(e: any) {
    e = e || window.event;
    const paste = (e.clipboardData).getData('text') as string;
    let nb;
    if (this.value && isNaN(Number(this.value)) || !this.value) {
      nb = paste.replace(/\D/g, '');
    } else {
      const currValue = String(this.value);
      nb = currValue.slice(0, e.target.selectionStart);
      nb += paste.replace(/\D/g, '');
      nb += currValue.slice(e.target.selectionEnd);
    }
    this.$emit('input', nb);

    e.preventDefault();
  }

  protected checkRangeValue(inputNumber: any): void {
    if (inputNumber < Number(this.minInput) || inputNumber > Number(this.maxInput)) {
      this.setInputValidity(false);
    } else {
      this.setInputValidity(true);
    }
  }

  protected setInputValidity(value: boolean): void {
    this.error = !value;
    this.$emit('is-input-number-valid', value);
  }

  protected resetInputValidity(): void {
    // Make sure to reset the put also, otherwise the validity will be inconsistent
    this.$emit('input', '');
    this.$emit('is-input-number-valid', true);
  }
}
